import callAPiBase from './base';

const fileApi = {
  get: ({ fileName }: { fileName: string }) =>
    callAPiBase({
      endpoint: `/api/file?name=${fileName}`,
      method: 'GET',
      useApiToken: true,
      useToken: false,
    }),

  create: ({ fileName, data }: { fileName: string; data: object }) =>
    callAPiBase({
      endpoint: `/api/file?name=${fileName}`,
      method: 'POST',
      useApiToken: true,
      useToken: false,
      data,
    }),
};

export { fileApi };
export default fileApi;
